import { render, staticRenderFns } from "./BaseInputText.vue?vue&type=template&id=cdbf701c&"
import script from "./BaseInputText.vue?vue&type=script&lang=js&"
export * from "./BaseInputText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports